import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';

export const GetAgeBand = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_AGE_BAND, token)
  return res;
};

export const GetAgeBandDetails = async (ageBandId) => {
  const token = localStorage.getItem("token");
  const params = { ageBandId };
  let res = await Services.GET(Url.GET_AGE_BAND + ageBandId, token)
  return res;
};

export const AddAgeBand = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_AGE_BAND, payload, token)
  return res;
};

export const DeleteAgeBand = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(Url.DELETE_AGE_BAND + id, params, token)
  return res;
};
